// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1134":"a7b7b099","1319":"56466248","2446":"9124a0dd","2453":"ed65a8a6","4921":"7a357c41","5067":"10191b25","7691":"298b1b74"}[chunkId] + ".chunk.css";
};